import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./css/MainPage.css";

// import PremiumBackground from "../kuyumcu/components/PremiumBackground";

import Footer from "../../components/Footer";
import TopNavbar from "../../components/TopNavbar";
import { isTokenExpired } from "../../utils/jwtUtils";


// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

// Resimler
import accounting from "../../img/accounting.png";
import muhasebeGorsel from "../../img/muhasebe-gorsel.png";
import muhasebeGorsel2 from "../../img/muhasebe-gorsel3.png";

const MainPage = () => {
  const navigate = useNavigate();

  const slides = useMemo(
    () => [
      {
        badge: "Kuyumcu Odaklı",
        title: "Prosetwin Muhasebe Sistemi",
        text: "Hesap, Kasa, Stok ve İşlem süreçlerinizi tek platformdan; hızlı, güvenli ve raporlanabilir şekilde yönetin.",
        img: accounting,
      },
      {
        badge: "Güncel Bakiye",
        title: "Kasa & Banka Yönetimi",
        text: "Altın, TL, döviz ve ziynet bakiyelerini tek ekrandan izleyin. İşlem geçmişi ve raporlar her an elinizin altında.",
        img: muhasebeGorsel2,
      },
      {
        badge: "Envanter Takibi",
        title: "Stok ve Envanter Yönetimi",
        text: "Altın/ziynet/stok hareketlerini firma bazında takip edin. Kontrol sizde, kayıtlar düzenli ve denetlenebilir.",
        img: muhasebeGorsel,
      },
    ],
    []
  );

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !isTokenExpired(token)) {
      navigate("/kuyumcu");
    }
  }, [navigate]);

  const goLogin = () => navigate("/login");

  return (
    <>
      <TopNavbar />

      {/* page-content SINIFINI BİLEREK KALDIRDIK (global layout çakışmasını kesmek için) */}
      <div className="main-page">
{/*         <PremiumBackground /> */}

        {/* LIGHT BACKGROUND ORNAMENTS */}
        <div className="mp-bg-orb mp-orb-1" />
        <div className="mp-bg-orb mp-orb-2" />
        <div className="mp-bg-grid" />

        {/* HERO */}
        <section className="mp-hero">
{/*           <PremiumBackground/> */}

          <div className="mp-container">
            <div className="mp-hero-shell">

              {/* HERO RIGHT - SLIDER */}
                <div className="mp-hero-card">
                  <Swiper
                    modules={[Autoplay]}
                    autoplay={{ delay: 5500, disableOnInteraction: false }}
                    loop={true}
                    slidesPerView={1}
                    spaceBetween={24}
                  >
                    {slides.map((slide, index) => (
                      <SwiperSlide key={index}>
                        <div className="mp-slide">
                          <div className="mp-slide-head">
                            <span className="mp-slide-badge">{slide.badge}</span>
                          </div>

                          <div className="mp-slide-body">
                            <div className="mp-slide-copy">
                              <h2 className="mp-slide-title">{slide.title}</h2>
                              <p className="mp-slide-text">{slide.text}</p>

                              <div className="mp-slide-actions">
                                <button
                                  className="mp-btn mp-btn-primary mp-btn-sm"
                                  onClick={goLogin}
                                >
                                  Giriş Yap
                                </button>
                                <button
                                  className="mp-btn mp-btn-soft mp-btn-sm"
                                  onClick={() => navigate("/register")}
                                >
                                  Kayıt Ol
                                </button>
                              </div>
                            </div>

                            <div className="mp-slide-media">
                              <img src={slide.img} alt={slide.title} />
                            </div>
                          </div>

                          <div className="mp-slide-foot">
                            <div className="mp-mini-stat">
                              <span className="mp-mini-stat-k">Modül</span>
                              <span className="mp-mini-stat-v">Kasa / Stok</span>
                            </div>
                            <div className="mp-mini-stat">
                              <span className="mp-mini-stat-k">Kapsam</span>
                              <span className="mp-mini-stat-v">Firma Bazlı</span>
                            </div>
                            <div className="mp-mini-stat">
                              <span className="mp-mini-stat-k">Yetki</span>
                              <span className="mp-mini-stat-v">Rol & İzin</span>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
          </div>
        </section>

        {/* FEATURES */}
        <section className="mp-section">
          <div className="mp-container">
            <div className="mp-section-head">
              <h2 className="mp-section-title">Temel Modüller</h2>
              <p className="mp-section-sub">
                İş akışınızı sadeleştiren ana ekranlar. Hepsine giriş yaptıktan sonra tek menüden ulaşırsınız.
              </p>
            </div>

            <div className="mp-feature-grid">
              <button className="mp-feature-card" onClick={goLogin} type="button">
                <div className="mp-feature-top">
                  <div className="mp-feature-ico" aria-hidden="true">🧾</div>
                  <span className="mp-feature-tag">İşlem</span>
                </div>
                <h3>Alış / Satış</h3>
                <p>Altın, ziynet, döviz bazlı hareketleri kayıt altına alın ve izleyin.</p>
                <div className="mp-feature-cta">Detayları Gör</div>
              </button>

              <button className="mp-feature-card" onClick={goLogin} type="button">
                <div className="mp-feature-top">
                  <div className="mp-feature-ico" aria-hidden="true">🏦</div>
                  <span className="mp-feature-tag">Bakiye</span>
                </div>
                <h3>Kasa & Banka</h3>
                <p>Kasa giriş/çıkış, tahsilat ve hareketleri panel üzerinden yönetin.</p>
                <div className="mp-feature-cta">Detayları Gör</div>
              </button>

              <button className="mp-feature-card" onClick={goLogin} type="button">
                <div className="mp-feature-top">
                  <div className="mp-feature-ico" aria-hidden="true">📦</div>
                  <span className="mp-feature-tag">Envanter</span>
                </div>
                <h3>Stok Yönetimi</h3>
                <p>Stok kartları, hareketler ve miktarları düzenli biçimde takip edin.</p>
                <div className="mp-feature-cta">Detayları Gör</div>
              </button>

              <button className="mp-feature-card" onClick={goLogin} type="button">
                <div className="mp-feature-top">
                  <div className="mp-feature-ico" aria-hidden="true">👥</div>
                  <span className="mp-feature-tag">Cari</span>
                </div>
                <h3>Müşteri / Hesap Takibi</h3>
                <p>Cari hesaplar, işlem geçmişi ve bakiyeler tek ekranda.</p>
                <div className="mp-feature-cta">Detayları Gör</div>
              </button>

              <button className="mp-feature-card" onClick={goLogin} type="button">
                <div className="mp-feature-top">
                  <div className="mp-feature-ico" aria-hidden="true">📊</div>
                  <span className="mp-feature-tag">Rapor</span>
                </div>
                <h3>Raporlama</h3>
                <p>Günlük/aylık raporlar, çıktı süreçleri ve analizler.</p>
                <div className="mp-feature-cta">Detayları Gör</div>
              </button>

              <button
                className="mp-feature-card mp-feature-card-highlight"
                onClick={() => navigate("/register")}
                type="button"
              >
                <div className="mp-feature-top">
                  <div className="mp-feature-ico" aria-hidden="true">✨</div>
                  <span className="mp-feature-tag">Başlangıç</span>
                </div>
                <h3>Kurulum Kolay</h3>
                <p>Hızlı kayıt, firma bilgileri ve kullanıcı yetkileriyle dakikalar içinde hazır.</p>
                <div className="mp-feature-cta">Hesap Oluştur</div>
              </button>
            </div>
          </div>
        </section>

        {/* CTA STRIP */}
        <section className="mp-cta">
          <div className="mp-container">
            <div className="mp-cta-inner">
              <div className="mp-cta-copy">
                <h2>Hazır mısınız?</h2>
                <p>
                  Prosetwin ile kuyumcu süreçlerini tek bir akışta yönetin.
                  Hemen giriş yapın veya yeni hesap oluşturun.
                </p>
              </div>

              <div className="mp-cta-actions">
                <button className="mp-btn mp-btn-primary" onClick={goLogin}>
                  Giriş Yap
                </button>
                <button
                  className="mp-btn mp-btn-ghost"
                  onClick={() => navigate("/register")}
                >
                  Kayıt Ol
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* SUMMARY */}
        <section className="mp-summary">
          <div className="mp-container">
            <div className="mp-summary-card">
              <h2>Verimli, Güvenli ve Hızlı</h2>
              <p>
                Prosetwin; kuyumcular ve küçük işletmeler için özel tasarlanmış modern bir muhasebe sistemidir.
                Firma bazlı yapı, rol/yetki modeli ve kayıt düzeniyle ölçeklenebilir bir altyapı sağlar.
              </p>
              <div className="mp-summary-badges">
                <span className="mp-pill">Responsive UI</span>
                <span className="mp-pill">Firma Bazlı</span>
                <span className="mp-pill">Yetki Sistemi</span>
                <span className="mp-pill">Rapor & Çıktı</span>
              </div>
            </div>
          </div>
        </section>

        <Footer>
        </Footer >
      </div>
    </>
  );
};

export default MainPage;
